'use client';

import {
	Box, defineStyle, Field,
} from '@chakra-ui/react';

import { useFormError } from '../../../hooks';
import type { FormFieldProps, FormValues } from '../../../types';

export const FormFloatingField = <T extends FormValues>(props: FormFieldProps<T>) => {
	const {
		children, helperText, label, name, optionalText, ...rest
	} = props;
	const { errorText, isError, isSubmitting } = useFormError(name);
	const Component = isError ? Field.ErrorText : Field.HelperText;
	const text = isError ? errorText : helperText;
	const floatingStyles = defineStyle({
		bg:            'bg',
		fontWeight:    'normal',
		insetStart:    '2',
		pointerEvents: 'none',
		pos:           'absolute',
		px:            '0.5',
		top:           '-3',
		transition:    'position',

		_peerFocusVisible: {
			color:      'fg',
			insetStart: '2',
			top:        '-3',
		},
		_peerPlaceholderShown: {
			color:      'fg.muted',
			insetStart: '3',
			top:        '2.5',
		},
	});

	return (
		<Field.Root disabled={isSubmitting} invalid={isError} {...rest}>
			<Box pos="relative" w="full">
				{children}
				<Field.Label css={floatingStyles}>
					{label}
					<Field.RequiredIndicator fallback={optionalText} />
				</Field.Label>
			</Box>
			{text && (
				<Component minH="14px" ml={1} textStyle="caption">
					{text}
				</Component>
			)}
		</Field.Root>
	);
};
